// import ReactDOM from "react-dom";

import * as ReactDOM from 'react-dom';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {AxiosError, AxiosResponse} from 'axios';
import {ApproversSection} from "./ApproversSection";
import {ProposalReviews} from "./ProposalReviews";
import {AppProps} from "./types.ts";
import {SendEmail} from "./SendEmail.tsx";
import axios from '../Utilities/axios.ts'

// import * as Toast from '@radix-ui/react-toast';

// import axios = require('axios').default;

// import axios from 'axios';
//
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.maxRedirects = 0;


// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// maxRedirects: 0

// proApi = axios.create({
//     baseURL: ''
// })
// interface ApproversGroup  {
//     l1Approvers: Array,
//     l2Approvers: Array
// }
//
// type ApproverList = Array<ApproversGroup>;


function ProposalSubmission(props: AppProps) {
    const {
        approvers, staffSignatureHtml,
        proposalId, clientIssues, reviewers, statusList
    } = props;


    const [data, setData] = useState({
        'dateApproved': props.dateApproved,
        'dateLastUpdated': props.dateLastUpdated,
        'proposalApprovals': props.proposalApprovals,
        'proposalApprovalRequests': props.proposalApprovalRequests,
        'proposalReviews': props.proposalReviews,
        'permissions': props.permissions,
        'approvalRequirementList': props.approvalRequirementList,
        'dateEmailed': props.dateEmailed,
        'questionResponses': props.questionResponses
    })

    console.log(props);


    const issues = {...clientIssues};
    Object.values(data.questionResponses).some((r) => r.value === 'No' && props.enquiryQuestionLookup[r.questionId].severity === 'danger')
    && (issues['error'] = [...(issues['error'] || []), 'Issues identified in Go/No Go Checksheet']);
    Object.values(data.questionResponses).some((r) => r.value === 'No' && props.enquiryQuestionLookup[r.questionId].severity === 'warning')
    && (issues['warning'] = [...(issues['warning'] || []), 'Issues identified in Go/No Go Checksheet']);

    // useEffect(() => {
    //     const numberOfApprovalsRequired = (props.currentProposalValue > props.proposalValueRequiringTwoApprovals) || issues['warning']?.length ? 2 : 1;
    //     if (data.numberOfApprovalsRequired != numberOfApprovalsRequired) setData({...data, numberOfApprovalsRequired: numberOfApprovalsRequired});
    // }, [issues])


    const [loading, setLoading] = useState(false);
    const [notice, setNotice] = useState<string | boolean>('');
    const [error, setError] = useState('');


    useEffect(() => {
        axios.interceptors.request.use((config) => {
            if (config.loadingSigns != 'disable') {
                setLoading(true);
                if (config.loadingMessage != 'disable')
                    setNotice(config.loadingMessage || 'Processing...');
            }

            return config;
        });

        return () => axios.interceptors.request.clear();

    }, [])
    const resHandler = (e: AxiosResponse, callBack = null) => {
        setLoading(false);
        console.log(e);
        setNotice(e.data.message);
        delete e.data.message;
        setError('');

        if (callBack) callBack();

        setData({...data, ...e.data})
        window.onbeforeunload = null;

        axios.get(`/enquiry/proposal/${proposalId}/main_section`, {loadingSigns: 'disable'})
            .then((_e: AxiosResponse) => {
                document.querySelector('#main_section').innerHTML = _e.data;
                // @ts-expect-error This function is defined as a browser include
                initAll(e.data.proposalApprovals.length);
                // @ts-expect-error This function is defined as a browser include
                window.setupDateWidget();
            });
    }
    const errHandler = (e: AxiosError) => {
        setLoading(false);
        setNotice(null);
        console.log('##error##');
        console.log(e);
        // @ts-expect-error thing
        setError('ERROR: ' + (e?.response?.data?.detail || e?.message || e));
    }
    useEffect(() => {
        if (!notice) return;
        const timeOut = setTimeout(() => setNotice(''), 5000);

        return () => {
            timeOut && clearTimeout(timeOut);
        }
    }, [notice])


    const rootUrl = '/proposal/' + proposalId;


    return Object.values(props.questionResponses).some(r => !r.value) ? (
            <div className='proposalSubmissionRight'>
                <h2 className="mb-3">Proposal Submission Process</h2>
                <div className={'alert-warning'}>All Go/No Go Questions must be responded before proposal can be
                    reviewed/submitted
                </div>
            </div>
        ) :
        (
            // <div className={'d-flex align-items-start'}>
            <>
                <div className='proposalSubmissionRight'>
                    <h2 className="mb-3">Proposal Submission Process</h2>


                    {
                        error ? (
                            <div className={`alert alert-error`}>
                                {error}
                            </div>
                        ) : ''
                    }
                    {
                        notice ? (
                            <div className={`alert alert-success d-flex align-items-center justify-content-between`}>
                                {notice}

                                <a style={{backgroundColor: '#dfdfdf'}}
                                   onClick={() => setNotice('')}
                                   className='js-delete_collection_entry '>x</a>
                            </div>
                        ) : ''
                    }


                    {issues['error'] && (
                        <div className={`alert alert-error`}>
                            <h4 className="pb-1">Proposal can be created but not submitted</h4>
                            <ul className="mb-0">
                                {issues['error']?.map(issue => (
                                    <li>{issue}</li>
                                ))}
                            </ul>
                        </div>
                    )}


                    <p className="mb-3">Please ensure <a href="/document/procedure_doc/MSDOC.324" target="_blank">
                        MSDOC.324</a> has been followed</p>

                    <ProposalReviews
                        multiDiscipline={
                            Object.values(data.questionResponses).some((r) => r.value === 'Yes' && props.enquiryQuestionLookup[r.questionId].severity === 'review_notice')
                        }
                        disabled={!data.permissions['proposal.reviewEnabled'] || !!issues['error']?.length}
                        reviewers={reviewers}
                        statusList={statusList} {...data} />


                    <ApproversSection queueMode={!data.permissions['proposal.approveEnabled'] && !data.dateApproved}
                                      disabled={(!data.permissions['proposal.approveEnabled'] && !!data.dateApproved) || !!issues['error']?.length}
                                      data={data}
                                      dateApproved={data.dateApproved}
                                      issues={issues}
                                      proposalValueRequiringTwoApprovals={props.proposalValueRequiringTwoApprovals}
                                      currentProposalValue={props.currentProposalValue}
                                      approvers={approvers}
                                      approvalRequirementList={data.approvalRequirementList}
                                      statusList={props.approvalStatusList}/>


                    {data.dateApproved || data.permissions['proposal.fastTrackSubmit'] ? (
                            <>
                                <SendEmail
                                    permissions={data.permissions}
                                    signatureHtml={staffSignatureHtml}
                                    approvalRequirementList={data.approvalRequirementList}
                                    subjectFields={props.subjectFields}
                                    // disabled={!data.permissions['proposal.sendEnabled']}
                                    dateEmailed={data.dateEmailed}
                                    defaultRecipient={props.clientContact?.conEmail}
                                    clientContactList={props.clientContactList}
                                    staffList={props.reviewers}
                                    issuesNotRequiringExtraApproval={issues['warning-subtle'] || []}
                                    rootUrl={rootUrl} loading={loading} errHandler={errHandler}
                                    proposalId={proposalId}
                                    dateApproved={data.dateApproved}
                                    fromEmail={props.currentStaff.stfBusEmail}
                                    resHandler={resHandler}/>

                            </>
                        )
                        :
                        ''

                    }

                </div>
            </>
        )
}

window["renderProposalSubmissionWidget"] = function (reviewsDto) {
    ReactDOM.render(<ProposalSubmission
            {...reviewsDto}
        />,
        document.querySelector('#proposalSubmissionWidget'));
}

